import gql from 'graphql-tag';

const GET_MSP_COMPANY = gql`
  query {
    getMSPCompany {
      customerId
      name
      currency
      timezoneCode
      city
      language
      # address
      line1
      line2
      line3
      countryCode
      stateCode
      postalCode
      dateFormat
      timeFormat
      subDomain
      canAlterSubDomain
      businessHour {
        day
        start
        end
      }
      holidayList {
        id
        name
      }
      working24x7
      logoFileName
      favIconFileName
      portalDomain
      customDomainAlias
      customDomain
      customDomainStatus #CustomDomainStatus
      senderName
      emailSignature
      # noOfDevices
      # noOfEmployees
      # currency
      # deviceCountOptions {
      #   id
      #   label
      # }
      # employeeCountOptions {
      #   id
      #   label
      # }
      # currencyOptions {
      #   id
      #   label
      # }
    }
  }
`;
const PRIMARY_COMPANY = `accountId
      name
      logoFileName
      emailDomains
      hqSite {
        id
        name
        timezoneCode
        working24x7
        address {
          addressId
          name
          line1
          line2
          line3
          city
          postalCode
          countryCode
          stateCode
          type
        }
        businessHour {
          day
          start
          end
        }
        holidayList {
          id
          name
        }
      }
      primaryContact {
        userId
        email
        firstName
        lastName
        name
        phoneNumber
        contactNumber
      }
      secondaryContact {
        userId
        email
        firstName
        lastName
        phoneNumber
        contactNumber
        name
      }
      companyOrg
      clientOrg
      
      details {
        currency
        language
        dateFormat
        timeFormat
        favIconFileName
        numberFormat {
          country
          currency
          language
        }
        portalDomains {
          domainId
          domainName
          type
          status
          isDefault
        }
        canAlterSubDomain
        customDomainAlias
        senderName
        emailSignature
        baseDomain
      }`;
const GET_PRIMARY_COMPANY = gql`
  query {
    getPrimaryCompany {
      ${PRIMARY_COMPANY}
    }
  }
`;

const GET_MSP_CONTACTS = gql`
  query {
    getMSPContacts {
      userId
      email
      firstName
      lastName
      phoneNumber
      contactNumber
      countryCode
      contactType
    }
  }
`;

const ADD_UPDATE_MSP_CONTACT = gql`
  mutation($contactList: [UserInput]) {
    addOrUpdateMSPContact(input: { contactList: $contactList }) {
      firstName
      lastName
      email
      phoneNumber
      countryCode
      contactType
    }
  }
`;

const UPDATE_MSP_COMPANY = gql`
  mutation($company: MSPCompanyInput) {
    updateMSPCompany(input: $company) {
      customerId
      name
      currency
      timezoneCode
      language
      city
      # address
      line1
      line2
      line3
      countryCode
      stateCode
      postalCode
      dateFormat
      timeFormat
      subDomain
      canAlterSubDomain
      businessHour {
        day
        start
        end
      }
      holidayList {
        id
        name
      }
      working24x7
      logoFileName
      favIconFileName
      portalDomain
      customDomain
      customDomainStatus #CustomDomainStatus
      senderName
      emailSignature
      # noOfDevices
      # noOfEmployees
      # currency
    }
  }
`;
const UPDATE_PRIMARY_COMPANY = gql`
  mutation($input: UpdateOrganizationInput!) {
    updatePrimaryCompany(input: $input) {
      ${PRIMARY_COMPANY}
    }
  }
`;

const UPDATE_OUTGOING_MAILSETTINGS = gql`
  mutation(
    $outgoingMailSettingsId: ID!
    # $senderName: String
    $replyTo: String # $emailSignature: String
  ) {
    updateOutgoingMailSettings(
      input: {
        outgoingMailSettingsId: $outgoingMailSettingsId
        # senderName: $senderName
        replyTo: $replyTo
        # emailSignature: $emailSignature
      }
    ) {
      outgoingMailSettingsId
      # senderName
      replyTo
      # emailSignature
    }
  }
`;

const UPDATE_MSPSUPPORT_MAILADDRESS = gql`
  mutation($supportEmailAddress: String) {
    updateMSPSupportEmailAddress(
      input: { supportEmailAddress: $supportEmailAddress }
    ) {
      supportEmailAddress
    }
  }
`;

const VERIFY_SUPPORTMAIL_MAILSETTINGS = gql`
  mutation($emailAddress: String) {
    verifySupportEmailAddressAvailability(emailAddress: $emailAddress) {
      verifySupportEmailAddressAvailability
    }
  }
`;

const GET_DATE_TIME_ALLOWED_FORMATS = gql`
  query {
    getDateTimeAllowedFormats {
      dates {
        format
        displayValue
      }
      times {
        format
        displayValue
      }
    }
  }
`;

const GET_NOTIFICATION_TEMPLATE_BY_CONSTANT = gql`
  query($notificationTemplateType: String!, $constant: String!) {
    getNotificationTemplateByConstant(
      notificationTemplateType: $notificationTemplateType
      constant: $constant
    ) {
      id
      activated
    }
  }
`;

export {
  GET_MSP_COMPANY,
  GET_MSP_CONTACTS,
  ADD_UPDATE_MSP_CONTACT,
  UPDATE_MSP_COMPANY,
  UPDATE_OUTGOING_MAILSETTINGS,
  VERIFY_SUPPORTMAIL_MAILSETTINGS,
  UPDATE_MSPSUPPORT_MAILADDRESS,
  GET_DATE_TIME_ALLOWED_FORMATS,
  GET_NOTIFICATION_TEMPLATE_BY_CONSTANT,
  GET_PRIMARY_COMPANY,
  UPDATE_PRIMARY_COMPANY
};
